import MDTypography from "components/MDTypography";
import { Icon, IconButton } from "@mui/material";
import MessageIcon from "@mui/icons-material/Message";
import CallIcon from "@mui/icons-material/Call";
import DoneIcon from "@mui/icons-material/Done";
import VideocamRoundedIcon from "@mui/icons-material/VideocamRounded";
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';

function DispatcherRowAction({
  row,
  value,
  onClickToCall,
  onClickToVideoCall,
  onClickToMessage,
  onClickToEmergencyConfJoin,
  onClickToConference,
  onClearSOS,
}) {
  const isAnnouncement = (row) =>
    row.callingGroup?.includes("Announcement") ||
    row.callingGroup?.includes("Drag And Drop") ||
    row.callingGroup?.includes("Conference");

  const isEndConference = (row) => row?.meetingStatus == 3;

  return (
    <MDTypography variant="caption" fontWeight="medium" color="text">
      <tooltip title="Call">
        {!isAnnouncement(row.original) && onClickToCall && (
          <IconButton
            color="success"
            onClick={() => onClickToCall(row.original)}
          >
            <CallIcon></CallIcon>
          </IconButton>
        )}
      </tooltip>
      <tooltip title=" Video Call">
        {!isEndConference(row.original) && onClickToVideoCall && (
          <IconButton
            color="info"
            onClick={() => onClickToVideoCall(row.original)}
          >
            <VideocamRoundedIcon></VideocamRoundedIcon>
          </IconButton>
        )}
      </tooltip>
      <tooltip title="Call">
        {isEndConference(row.original) && onClickToConference && (
          <Icon
            color="success"
            fontSize="medium"
            style={{ paddingLeft: "5px" }}
          >
            <DoneIcon></DoneIcon>
          </Icon>
        )}
      </tooltip>
      <tooltip title="Message">
        {!isAnnouncement(row.original) && onClickToMessage && (
          <IconButton
            color="success"
            onClick={() => onClickToMessage(row.original)}
          >
            <MessageIcon></MessageIcon>
          </IconButton>
        )}
      </tooltip>
      <tooltip title="Emergency Call">
        {!isAnnouncement(row.original) && onClickToEmergencyConfJoin && (
          <IconButton
            color="primary"
            onClick={() => onClickToEmergencyConfJoin(row.original)}
          >
            <CallIcon></CallIcon>
          </IconButton>
        )}
      </tooltip>

      <tooltip title="Clear SOS">
        {!isAnnouncement(row.original) && onClearSOS && (
          <IconButton color="error" onClick={() => onClearSOS(row.original)}>
            <LocalHospitalIcon></LocalHospitalIcon>
          </IconButton>
        )}
      </tooltip>
    </MDTypography>
  );
}

export default DispatcherRowAction;
